<template>
  <!-- <el-dialog class="rt-lookup-dialog" width="33.3%" :close-on-click-modal="false" title="查找" :visible.sync="dialogVisible"> -->
  <el-dialog
    append-to-body
    class="rtportal rt-lookup-dialog big-dialog"
    :close-on-click-modal="false"
    :title="dialogTitle || $tx('查找')"
    :visible.sync="dialogVisible"
  >
    <el-row>
      <el-col :span="4">{{$tx('搜索')}}</el-col>
      <el-col :span="20">
        <el-input
          v-model="filterValue"
          @keyup.enter.native="handleSearch"
          :placeholder="entity == 'account'?$tx('请输入完整税号或客户名称'):$tx('搜索记录')"
        >
          <el-button
            type="text"
            slot="append"
            icon="el-icon-search"
            style="margin-top:-12px;"
            @click="handleSearch"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      ref="lookupTable"
      style="width: 100%"
      height="58%"
      :row-class-name="tabRowClassName"
      highlight-current-row
      :header-cell-style="{background:'#F8F9FA'}"
      v-bind:data="tableData"
      border
      stripe
      @current-change="handleCurrentChange"
      @row-dblclick="handleConfirm"
      @sort-change="handleSortChange"
      v-loading="loading"
    >
      <el-table-column width="55">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row == currentRow"></i>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        v-for="display in displayFields"
        v-bind:key="display.name"
        :prop="display.name"
        :label="display.label"
        :width="display.width"
      ></el-table-column>
      <template slot="empty">
        <img style="margin-top:50px;" src="../../../src/assets/imgs/home/no-order.png" alt />
        <p class="nodata-prompt">哎呀，暂时没有内容哦～</p>
      </template>
    </el-table>
    <div slot="footer" class='pagination-wrap'>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleIndexChange"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="totalRecordCount"
        style="margin-bottom:10px;text-align: center;"
      ></el-pagination>
      <span class="dialog-footer">
        <el-button @click="handleReset">{{$tx('移除值')}}</el-button>
        <el-button type="primary" @click="handleConfirm">{{$tx('确 定')}}</el-button>
        <el-button type="primary" @click="createAccount" v-if="entity == 'account' && canCreate=='true'">{{$tx('新建客户')}}</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RtLookupDialog",
  props: {
    entity: {
      type: String,
      required: true
    },
    requestUrl: {
      type: String,
      default: function() {
        return "../api/crmlookupview/data";
      }
    },
    nameField: {
      type: String,
      default: function() {
        return "new_name";
      }
    },
    idField: {
      type: String,
      default: function() {
        return this.entity + "id";
      }
    },
    displayFields: {
      type: Array,
      default: function() {
        return [
          { name: "new_name", label: this.$tx("名称") },
          {
            name: "createdon",
            label: this.$tx("创建时间"),
            width: 180
          }
        ];
      }
    },
    orderbyFields: {
      type: String,
      default: function() {
        return "createdon desc";
      }
    },
    customConditions: {
      type: String,
      default: function() {
        return "";
      }
    },
    filterFields: {
      type: String,
      default: function() {
        return "new_name";
      }
    },
    returnFields: {
      type: String
    },
    dialogTitle: String,
    new_industry_id:{
      type:Object,
    },
    new_orderId:{
      type:String,
    },
    canCreate:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,

      filterValue: "",

      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next",
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,

      tableData: [],
      currentRow: null,
    };
  },
  computed: {

    dialogTitle() {
      return this.$props.dialogTitle;
    },
    selectString: {
      get() {
        //将idField、nameField、displayFields、returnFields合并，并去掉重复的字段
        var selectFields;
        // console.log(this.canCreate);
        if (this.returnFields) {
          selectFields = this.returnFields.split(",");
        } else {
          selectFields = [];
        }

        selectFields.push(this.nameField);
        selectFields.push(this.idField);

        for (var i in this.displayFields) {
          var fieldName = this.displayFields[i].name;
          if (selectFields.indexOf(fieldName) >= 0) {
            continue;
          }
          selectFields.push(fieldName);
        }

        return selectFields.join(",");
      }
    },
    orderbyString: {
      get() {
        return this.orderbyFields;
      }
    },
    conditionString: {
      get() {
        return this.customConditions;
      }
    },
    filterString: {
      get() {
        return this.filterFields;
      }
    }
  },
  mounted() {},
  methods: {
    //在methods总通过方法计算返回对应class样式
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "even-row";
      }
    },
    show() {
      if(this.entity == "new_mediumindustry" || this.entity == "new_smallindustry"){
        if(this.new_industry_id == undefined || this.new_industry_id.id == null || this.new_industry_id.id == ""){
          rt.showErrorToast("请选择行业上级");
          return;
        }
      }else if(this.entity == "new_city" || this.entity == "new_county"){
        if(this.new_industry_id == undefined || this.new_industry_id.id == null|| this.new_industry_id.id == ""){
          rt.showErrorToast("请选择省市区上级");
          return;
        }
      }
      this.dialogVisible = true;
      this.filterValue = "";//再次进来时重置搜索框数据
      this.pageIndex = 1;
      this.$nextTick(() => {
        this._fetchRecords();
      })

    },
    handleSearch() {
      this.pageIndex = 1;
      this.$nextTick(() => {
        this._fetchRecords();
      })
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSortChange() {
      alert("未实现");
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageIndex = 1;
      this.$nextTick(() => {
        this._fetchRecords();
      })

    },
    handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.$nextTick(() => {
        this._fetchRecords();
      })

    },
    handleReset() {
      this.$emit("data-selected", {
        id: null,
        logicalName: this.logicalName,
        name: null
      });

      this.dialogVisible = false;
    },
    handleConfirm() {
      var selectedRow = this.$refs.lookupTable.store.states.currentRow;
      if (rt.isNull(selectedRow)) {
        rt.showErrorToast("请选择一条记录");
        return;
      }

      var retValue = {
        id: selectedRow[this.idField],
        name: selectedRow[this.nameField]
      };

      if (this.returnFields) {
        var fieldList = this.returnFields.split(",");
        for (var i in fieldList) {
          retValue[fieldList[i]] = selectedRow[fieldList[i]];
        }
      }

      this.$emit("data-selected", retValue);

      this.dialogVisible = false;
    },
    createAccount(){
      this.$router.push({ name: "newAccount" });
    },
    //数据加载
    _fetchRecords() {
      // if(this.entity == "new_mediumindustry" || this.entity == "new_smallindustry"){
      //   if(this.new_industry_id == undefined || this.new_industry_id.id == null || this.new_industry_id.id == ""){
      //     this.dialogVisible = false;
      //     rt.showErrorToast("请选择行业上级");
      //     return;
      //   }
      // }else if(this.entity == "new_city" || this.entity == "new_county"){
      //   if(this.new_industry_id == undefined || this.new_industry_id.id == null|| this.new_industry_id.id == ""){
      //     this.dialogVisible = false;
      //     rt.showErrorToast("请选择省市区上级");
      //     return;
      //   }
      // }
      var industryid;
      if(this.new_industry_id == undefined || this.new_industry_id.id == null || this.new_industry_id.id == ""){
        industryid = "";
      }else if(this.new_industry_id != undefined && this.new_industry_id.id != null && this.new_industry_id.id != ""){
        industryid = this.new_industry_id.id;
      }
      var orderId;
      if(this.new_orderId == undefined || this.new_orderId == null || this.new_orderId == ""){
        orderId = "";
      }else if(this.new_orderId != undefined && this.new_orderId != null && this.new_orderId != ""){
        orderId = this.new_orderId;
      }
      this.loading = true;
      var requestStr =
        this.requestUrl +
        "?entityName=" +
        this.entity +
        "&page=" +
        this.pageIndex +
        "&count=" +
        this.pageSize +
        "&select=" +
        this.selectString +
        "&orderby=" +
        this.orderbyString +
        "&condition=" +
        this.conditionString +
        "&filter=" +
        this.filterString +
        "&filterValue=" +
        encodeURIComponent(this.filterValue || "");

      if (this.entity != "new_ord_saleorder"){
        requestStr += ("&new_industry_id="+encodeURIComponent(industryid|| ""));
        requestStr += ("&new_orderId="+encodeURIComponent(orderId|| ""));
      }

      rt.get(requestStr)
        .then(res => {
          this.tableData = res.Data;
          this.totalRecordCount = res.TotalRecordCount;

          this.$nextTick(() => {
            this.$refs.lookupTable.doLayout();
          });

          this.loading = false;
        })
        .catch(error => {
          rt.showErrorToast(error);

          this.loading = false;
        });
    }
  }
};
</script>
<style  type="scoped">
.rt-lookup-dialog .el-dialog {
  position: relative;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  min-width: 650px;
  margin: 0px !important;
}

.rt-lookup-dialog .el-form-item .el-form-item__label {
  width: 120px;
}

.rt-lookup-dialog .el-form-item .el-form-item__label:before {
  display: none;
}

.rt-lookup-dialog .el-form-item .el-form-item__content {
  margin-left: 120px !important;
}

.rt-lookup-dialog .el-table {
  margin-top: 15px;
  /* 修改的是商机，支持销售 */
  padding-bottom: 100px;
    box-sizing: border-box;
}
/* 修改的是商机，支持销售 */
.rt-lookup-dialog .el-table__body-wrapper {
    height: calc(100% - 40px) !important;
}

.rt-lookup-dialog .el-dialog__body {
  padding-bottom: 15px;
}
.big-dialog .el-row {
  padding: 15px 20px 0 15px;
  line-height: 2;
  color: #143e81 !important;
}
.big-dialog .el-dialog {
    /* height: 76.3% !important;
    width: 45.4% !important;
    margin-top: 4% !important; */
}
.el-icon-circle-check:before {
  display: none !important;
}
.el-input__validateIcon {
  display: none !important;
}
</style>




// WEBPACK FOOTER //
// lookup-dialog.vue?ca74258e